import React, { useState, useCallback, useEffect } from "react";
import "./index.css";
import { Modal, Button } from "react-bootstrap";
import {
	Input,
	InputNumber,
	Form,
	Spin,
	Modal as AntdModal,
	Checkbox,
} from "antd";
import _ from "lodash";
import toast from "react-hot-toast";
import { checkIsJSON } from "../DoctaChatBox";
import { DownMoreData, GetQuote } from "../../../api/Api";
import { CN_TEXT, US_TEXT } from "../../../config";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../providers/CustomThemeProvider";

interface IProps {
	data: any;
}

const MoreDataBtn = (props: IProps) => {
	const { data } = props;
	const { t, i18n } = useTranslation();

	const [show, setShow] = useState(false);
	const [value, setValue] = useState<number>(1);
	const [form] = Form.useForm();
	const [cost, setCost] = useState<string>("0");
	const [loading, setLoading] = useState<boolean>(false);
	// const [dataType, setDataType] = useState<string>("");
	// const [dataClass, setDataClass] = useState<string>("");
	const [topic, setTopic] = useState<string>("");
	const [userPrompt, setUserPrompt] = useState<string>("");
	const [disable, setDisable] = useState<boolean>(false);
	const [isShow, setIsShow] = useState<boolean>(false);
	const { isDarkMode, switchTheme } = useTheme();
	const [modality, setModality] = useState<any>("");
	const [sendToDLP, setSendToDLP] = useState<boolean>(false);

	const isArrayNotEmpty = (value: any) =>
		Array.isArray(value) && value.length > 0;

	const debouncedChangeHandler = useCallback(
		_.debounce(async (input) => {
			setValue(input);
			if (input) {
				await getCost(input);
			}
		}, 1000),
		[]
	);

	useEffect(() => {
		console.log("wantmoredata", data, data?.modality);
		setModality(data?.modality ?? "");

		setIsShow(data?.reture_type != "single_message");
		setTopic(
			isArrayNotEmpty(data?.topics_search_tag)
				? data?.topics_search_tag?.[0]
				: data?.topics_search_tag ?? 0
		);
		setUserPrompt(
			isArrayNotEmpty(data?.topic)
				? data?.topic?.[0]
				: data?.topics_search_tag ?? 0
		);
		// }
		// } catch (error) {
		// 	console.error("Failed to parse data", error);
		// }
	}, [data]);

	const getCost = async (input: number) => {
		setLoading(true);
		try {
			// if (checkIsJSON(data)) {
			// const parsedData = JSON.parse(data);
			const parsedData = data;
			console.log("======getCost=>parsedData", parsedData);

			if (parsedData?.topic === "low similarity") {
				// 根据当前数据的平均长度估计价格
				const wordcount = data?.split(" ")?.length;
				const cost = (
					(input * wordcount) /
					Object.keys(parsedData?.data)?.length /
					1000000
				).toString();
				console.log("getCost=>estimate cost", cost);

				setTimeout(() => {
					setCost(cost);
					setLoading(false);
				}, 500);
			} else {
				const tag = isArrayNotEmpty(parsedData?.topics_search_tag)
					? parsedData?.topics_search_tag?.[0]
					: parsedData?.topics_search_tag;
				// if (isArrayNotEmpty(tag)) {
				// 	tag =
				// }
				/* eslint-disable @typescript-eslint/no-explicit-any */
				const res = (await GetQuote({
					tag: tag,
					amount: input,
				})) as any;
				if (res?.quotedValue) {
					setCost(res?.quotedValue);
					setLoading(false);
				}
			}
			// }
		} catch (e) {
			console.log(e);
		}
	};

	useEffect(() => {
		return () => {
			debouncedChangeHandler.cancel();
		};
	}, [debouncedChangeHandler]);

	const handleClick = () => {
		setCost("0");
		setShow(true);
		setDisable(false);
	};

	const onHide = () => {
		setShow(false);
		setCost("0");
		form.resetFields();
	};

	const success = () => {
		AntdModal.success({
			title: "Your request has been successfully submitted. ",
			content:
				"You will receive the data within 10 minutes. Please refrain from re-submitting to avoid additional charges.",
		});
	};

	const handleSubmit = async () => {
		// console.log(dataClass, dataType, topic, userPrompt);
		const values = form.getFieldsValue();
		if (!values?.number || !values?.email) {
			toast.error("Please check your input");
			return;
		}
		try {
			// 响应比较慢所以先给了提示，可能会导致问题，即请求其实没有成功
			success();
			setDisable(true);

			await DownMoreData({
				tag: topic,
				amount: values?.number,
				email: values?.email,
				userPrompt: userPrompt,
				modality: modality,
				sendToDLP: sendToDLP,
			});
			// toast.success("Your request has been successfully submitted. ");
		} catch (e) {
			console.log(e);
			toast.error("Unable to download");
		}
	};

	return (
		isShow && (
			<>
				{/* <Alert
				message="Success Tips"
				description="You will receive the data within 10 minutes, please do not re-submit to incur additional charges."
				type="success"
				showIcon
			/> */}
				<div className="more-data-btn" onClick={handleClick}>
					{i18n.language == "en" ? US_TEXT.WANTMOREDATA : CN_TEXT.WANTMOREDATA}
				</div>
				<Modal
					show={show}
					onHide={onHide}
					centered
					className={`set-up-modal ${
						isDarkMode ? "dark-theme" : "light-theme"
					}`}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{i18n.language == "en" ? "Get More Data" : "获取更多数据"}
						</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<div className="more-data-btn-content-wrapper">
							<Form form={form}>
								<div className="number-input-wrapper">
									{i18n.language == "en" ? "Select" : "选择"}
									<Form.Item name="number" className="number-input">
										<InputNumber
											min={1}
											// max={10000}
											// defaultValue={0}
											value={value}
											onChange={(value) => {
												debouncedChangeHandler(value);
											}}
										/>
									</Form.Item>
									{i18n.language == "en" ? "more data." : "条数据。"}

									{/* in [{topic}] class: */}
								</div>
								<div className="estimated">
									{i18n.language == "en"
										? "Estimate Total Cost:"
										: "预估费用："}

									<div className="estimated-number">
										{loading ? (
											<Spin size="small" spinning={loading} />
										) : (
											<>
												{parseFloat(cost) <= 1 ? (
													<>
														{i18n.language == "en" ? "less than $1" : "少于1元"}
													</>
												) : (
													<>$ {Math.ceil(parseFloat(cost))}</>
												)}
											</>
										)}
									</div>
								</div>
								<Form.Item
									name="email"
									rules={[
										({ getFieldValue }) => ({
											validator() {
												if (!getFieldValue("email")) {
													return Promise.reject("Email is required");
												} else {
													const emailRegex = /^[A-Za-z0-9+_.-]+@(.+)$/;
													if (emailRegex.test(getFieldValue("email"))) {
														return Promise.resolve();
													}
													return Promise.reject("Not a valid Email address");
												}
											},
										}),
									]}
								>
									<Input
										placeholder={
											i18n.language == "en"
												? "Enter an email address to receive data"
												: "输入您的邮箱接收数据"
										}
									/>
								</Form.Item>
								<Checkbox
									onChange={() => setSendToDLP(!sendToDLP)}
									checked={sendToDLP}
								>
									sendToDLP
								</Checkbox>
							</Form>
							<div>
								{i18n.language == "en"
									? "You will receive details on how to download the data in your email."
									: "你将会在邮件中获取下载数据的方法。"}
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="success" onClick={handleSubmit} disabled={disable}>
							{i18n.language == "en" ? "Submit" : "提交"}
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		)
	);
};

export default MoreDataBtn;
